type ToggleSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  color?: string;
  slot?: string;
  'data-testid'?: string;
};

export function ToggleSwitch({
  checked,
  onChange,
  disabled,
  color,
  slot,
  'data-testid': testId,
}: ToggleSwitchProps) {
  const classes = ['toggle'];
  if (color) classes.push(`color-${color}`);
  if (disabled) classes.push('disabled');

  return (
    <label className={classes.join(' ')} slot={slot ?? 'after'} data-testid={testId}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle-icon" />
    </label>
  );
}
export default ToggleSwitch;
